// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c13788b","732":"834f825d","977":"e5a8f6ab"}[chunkId] + ".chunk.js";
};